import type { ReactNode } from 'react';
import { useCallback } from 'react';

import type { FormAsyncComboboxProps } from '@/_components';
import { FormAsyncCombobox, PrimaryLink } from '@/_components';

import { useGetDepartmentsMutation } from '../apis';
import type { DepartmentQuerySchemaBase } from '../department-query-schema';

export function DepartmentSelect({
  disabled,
  ...props
}: FormAsyncComboboxProps<Omit<DepartmentQuerySchemaBase, 'parent' | 'children'>>) {
  const getName = useCallback(
    (item?: DepartmentQuerySchemaBase | null): ReactNode => {
      if (!item) {
        return '';
      }

      const itemName = item.name;

      if (!disabled) {
        return itemName;
      }

      return (
        <PrimaryLink to="/settings/departments/$id" params={{ id: `${item.id}` }} state={{ naturalBack: true }}>
          {itemName}
        </PrimaryLink>
      );
    },
    [disabled]
  );

  return (
    <FormAsyncCombobox
      {...props}
      itemToString={getName}
      keyExtractor={(item) => item?.id?.toString?.() ?? null}
      useApi={useGetDepartmentsMutation}
      disabled={disabled}
    />
  );
}
